module.exports = __webpack_public_path__ + "static/media/twitter.30e4545d.svg";